import React, {FunctionComponent} from 'react';
import {_ReactPixi} from '@inlet/react-pixi';
import {ArrowButton} from '@gongxigames/framework/slot/modules/loadingScreen/components/Slides/ArrowButton';
import {utilArray} from '@gongxigames/framework/lib/util/utilArray';

export type ArrowsProps = Omit<_ReactPixi.IContainer, 'position' | 'scale'> & {
    slides: number;
    activeIndex: number;
    setIndex: (i: number) => void;
    arrowsPosition?: [number, number];
};

export const Arrows: FunctionComponent<ArrowsProps> = ({setIndex, arrowsPosition, slides, activeIndex}) => {
    const x = arrowsPosition?.[0] ?? 932;
    const y = arrowsPosition?.[1] ?? -868;

    return <>
        <ArrowButton
            key={1}
            press={() => setIndex(utilArray.normalizeIndexFromReelStrip(slides, activeIndex + 1))}
            position={[x, y]}
        />
        <ArrowButton
            key={2}
            press={() => setIndex(utilArray.normalizeIndexFromReelStrip(slides, activeIndex - 1))}
            position={[-x, y]}
            flip={true}
        />
    </>;
};
